import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { WalletStateT, WalletBalanceT, InstrumentPairBalanceT } from 'types';

export const initialWalletState: WalletStateT = {
  nativeBalance: null,
  instrumentPairBalance: { baseCurrency: '0', quoteCurrency: '0' },
};

const walletSlice = createSlice({
  name: 'wallet',
  initialState: initialWalletState,
  reducers: {
    setNativeBalance(state, action: PayloadAction<WalletBalanceT | null>) {
      state.nativeBalance = action.payload;
    },
    setInstrumentPairBalance(state, action: PayloadAction<InstrumentPairBalanceT>) {
      state.instrumentPairBalance = action.payload;
    },
  },
});

export const { setNativeBalance, setInstrumentPairBalance } = walletSlice.actions;

export default walletSlice.reducer;
